import { render, staticRenderFns } from "./red-packet-open.mpx?vue&type=template&id=9985e124&scoped=true&isComponent&outputPath=components%2Fred-packet-open09b1ea94%2Findex"
import script from "./red-packet-open.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fred-packet-open09b1ea94%2Findex"
export * from "./red-packet-open.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fred-packet-open09b1ea94%2Findex"
import style0 from "./red-packet-open.mpx?vue&type=style&index=0&id=9985e124&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m09b1ea94%22%7D&isComponent&outputPath=components%2Fred-packet-open09b1ea94%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9985e124",
  null
  
)

export default component.exports